module.exports = __webpack_public_path__ + "img/self-care.70860fce.png";